/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 31/07/13
 * Time: 10:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('CureItemToService_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource( baseUrl + 'rest/cureItemToServices/:id' , {} ,
            {
                query: { method: 'GET', isArray: true },
                get:   { method: 'GET' },
                getDeleted: { method: 'GET', isArray: true , url:baseUrl+'rest/cureItemToServices/deleted'}
            }
        );
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('CureItemToService',["CureItemToService_Resource","CureItemToServiceData","ServiceData","CureItemToServiceUsage",
        function (CureItemToService_Resource,CureItemToServiceData,ServiceData,CureItemToServiceUsage)
    {

        var CureItemToService = function (resource,cureItem,mustloadElements)
        {
            this.id = null;
            this.isDeleted;
            this.service =null;
            this.quantity =0;
            this.cureItem = cureItem;
            this.cureItemToServiceUsages = [];
            this.version = null;
            if (resource !== undefined && resource != null)
            {
                this.loadObjectProperties(resource);
                if (mustloadElements)
                    this.loadObjectCureItemToServiceUsages(resource);
            }
            CureItemToServiceData.add(this);
        }
        CureItemToService.prototype.loadObjectProperties = function(object)
        {
            if (!this.id)
                this.id = object.id;
            if (object.version)
                this.version = object.version;
            this.isDeleted = object.isDeleted;
            this._serviceId = object.serviceId;
            this.quantity = object.quantity;

        };
        CureItemToService.prototype.loadObjectCureItemToServiceUsages = function(object)
        {
            this.cureItemToServiceUsages = [];
            if (object.cureItemToServiceUsages)
                for (var i=0;i<object.cureItemToServiceUsages.length;i++)
                    this.cureItemToServiceUsages.push(new CureItemToServiceUsage(object.cureItemToServiceUsages[i],this))
        }
        CureItemToService.prototype.getObjectResource = function()
        {
            var rsCureItemToService = new CureItemToService_Resource();
            rsCureItemToService.id = this.id;
            rsCureItemToService.isDeleted = this.isDeleted;
            rsCureItemToService.quantity = this.quantity;
            if (this.service)
                rsCureItemToService.serviceId =  this.service.id;

            //do not save  cureItemToServiceUsages on this resource

            return rsCureItemToService;
        }

        CureItemToService.prototype.loadRef =  function()
        {
            this.service = ServiceData.getById(this._serviceId);
            if (!this.service && this.cureItem && this.cureItem.saleCure && this.cureItem.saleCure.cure && this.cureItem.saleCure.cure.cureToServices.length==1
            && this.cureItem.saleCure.cure.cureToServices[0].service) // security to avoid error
                this.service = this.cureItem.saleCure.cure.cureToServices[0].service
/*
            for (var i=0;i<this.cureItemToServiceToServices.length;i++)
                this.cureItemToServiceToServices[i].service = ServiceData.getById(this.cureItemToServiceToServices[i]._serviceId);
*/
        }
        CureItemToService.prototype.getId = function()
        {
            return this.id;
        }
        CureItemToService.prototype.setId = function(id)
        {
            this.id = id;
        };
        CureItemToService.prototype.addCureItemToServiceUsage = function(cureItemToServiceUsage)
        {
            if (cureItemToServiceUsage)
            {
                var index = this.cureItemToServiceUsages.indexOf(cureItemToServiceUsage);
                if (index==-1)
                    this.cureItemToServiceUsages.push(cureItemToServiceUsage);
                cureItemToServiceUsage.cureItemToService = this;
            }
        }
        CureItemToService.prototype.removeCureItemToServiceUsage = function(cureItemToServiceUsage)
        {
            if (cureItemToServiceUsage)
            {
                var index = this.cureItemToServiceUsages.indexOf(cureItemToServiceUsage);
                if (index!=-1)
                    this.cureItemToServiceUsages.splice(index,1);
                cureItemToServiceUsage.cureItemToService =null;
            }
        }
        CureItemToService.prototype.isUsed = function()
        {
            var usedQuantity = 0;
            for (var i=0;i<this.cureItemToServiceUsages.length;i++)
                usedQuantity += this.cureItemToServiceUsages[i].usedQuantity;
            return usedQuantity>=this.quantity;
        };
        return CureItemToService;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('CureItemToServiceSrv',["$log","CureItemToService_Resource","CureItemToService","UserActionData","CureItemToServiceData","ServerSrv","CureItemData",
        function ($log,CureItemToService_Resource,CureItemToService,UserActionData,CureItemToServiceData,ServerSrv,CureItemData)
    {
        var  cureItemToServiceSrv =
        {};
        cureItemToServiceSrv.save =  function(cureItemToService,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(cureItemToServiceSrv.saveSync, cureItemToService, successFunction, errorFunction);
        };
        cureItemToServiceSrv.saveSync = function(cureItemToService,successFunction,errorFunction)
        {
            var CureItemToServiceRes = cureItemToService.getObjectResource();
            CureItemToServiceRes.$save({}, //no params
                function (data) {
                    try{
                        if(cureItemToService.id == null) {
                            cureItemToService.setId(data.id);
                        }
                        /** @namespace data.supplierId */
                        if (data.supplierId && cureItemToService.supplier)
                            cureItemToService.supplier.id = data.supplierId;

                        if (successFunction !=undefined)
                            successFunction(data);

                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        }
        cureItemToServiceSrv.remove =  function(cureItemToService,successFunction,errorFunction)
        {
            CureItemToServiceData.remove(cureItemToService);
            ServerSrv.startSavingProcess(cureItemToServiceSrv.removeSync, cureItemToService, successFunction, errorFunction);
        };
        cureItemToServiceSrv.removeSync =  function(cureItemToService,successFunction,errorFunction)
        {
            var cureItemToServiceRes = new CureItemToService_Resource();
            cureItemToServiceRes.$remove({id:cureItemToService.getId()}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        }
        cureItemToServiceSrv.restore =  function(cureItemToService,successFunction,errorFunction)
        {
            CureItemToServiceData.restore(cureItemToService);
            ServerSrv.startSavingProcess(cureItemToServiceSrv.restoreSync, cureItemToService, successFunction, errorFunction);
        };
        cureItemToServiceSrv.restoreSync =  function(cureItemToService,successFunction,errorFunction)
        {
            //$timeout (function () {

            var cureItemToServiceRes = cureItemToService.getObjectResource();
            cureItemToServiceRes.$save({}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }
        cureItemToServiceSrv.query = function(successFunction,errorFunction)
        {
            CureItemToService_Resource.getDeleted(
                {}, //params
                function (data) {   //success

                    CureItemToServiceData.deletedCureItemToServices = [] ;
                    for (var i=0;i< data.length;i++)
                        new CureItemToService(data[i]);//Auto Add to CureItemToServiceData

                    if (successFunction!== undefined )
                        successFunction(CureItemToServiceData.categoryRoot);
                },
                function (data) {   //failure
                    $log.error("CureItemToService_Resource.getDeleted error");
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);

                });
        }
        cureItemToServiceSrv.loadRef =  function()
        {
            var cureItemToServices = CureItemToServiceData.indexCureItemToServices;
            for (var i=0;i<cureItemToServices.length;i++)
                cureItemToServices[i].loadRef();

        }
        cureItemToServiceSrv.updateLocally =  function(id,resource)
        {
            var cureItemToService = CureItemToServiceData.getById(id);
            if (cureItemToService!=null)
            {
                cureItemToService.loadObjectProperties(resource);
                cureItemToService.loadRef();
            }
            return cureItemToService
        };
        cureItemToServiceSrv.addLocally =  function(id,resource)
        {
            var cureItemToService = CureItemToServiceData.getById(id);
            if (cureItemToService!=null)
                cureItemToService.loadObjectProperties(resource);
            else
            {
                cureItemToService = new CureItemToService(resource,null,false);
                cureItemToService.id = id;
            }
            cureItemToService.loadRef();
            if (resource.cureItemId)
            {
                var cureItem = CureItemData.getById(resource.cureItemId);
                if (cureItem)
                    cureItem.addCureItemToService(cureItemToService);
            }
            return cureItemToService;
        };
        cureItemToServiceSrv.removeLocally =  function(id,resource)
        {
            var cureItemToService = CureItemToServiceData.getById(id);
            if (cureItemToService!=null)
            {
                //remove from sale
                if(cureItemToService.cureItem)
                    cureItemToService.cureItem.removeCureItemToService(cureItemToService);
            }
            return cureItemToService;
        };
        


        return cureItemToServiceSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('CureItemToServiceData',["$log", function ($log)
    {
        var  cureItemToServiceData =
        {
            indexCureItemToServices : [], //Used as Index
            deletedCureItemToServices : []
        };
        cureItemToServiceData.getById =  function(cureItemToServiceId)
        {
            for (var i=0;i<this.indexCureItemToServices.length;i++)
                if (this.indexCureItemToServices[i].id==cureItemToServiceId)
                    return this.indexCureItemToServices[i];
            return null;
        }
        cureItemToServiceData.getByIndex =  function(servIndex)
        {
            if (servIndex>=0 && servIndex<this.indexCureItemToServices.length)
            {
                return this.indexCureItemToServices[servIndex];
            }
            else
                return null;
        }
        cureItemToServiceData.getIndexOf =  function(cureItemToService)
        {
            if (cureItemToService)
                return this.indexCureItemToServices.indexOf(cureItemToService);
            return -1;
        }
        cureItemToServiceData.add =  function(cureItemToService)
        {
            this.indexCureItemToServices.push(cureItemToService);
            if (cureItemToService.isDeleted)
            {
                var index = this.deletedCureItemToServices.indexOf(cureItemToService)
                if (index==-1)
                    this.deletedCureItemToServices.push(cureItemToService);
            }
            return this.indexCureItemToServices.length-1;
        }
        cureItemToServiceData.remove =  function(cureItemToService) //Soft Remove
        {
            var index =  this.deletedCureItemToServices.indexOf(cureItemToService);
            if (index==-1)
            {
                this.deletedCureItemToServices.push(cureItemToService)
                cureItemToService.isDeleted=true;
            }

        }
        cureItemToServiceData.restore =  function(cureItemToService) //Soft Remove
        {
            var index =  this.deletedCureItemToServices.indexOf(cureItemToService);
            if (index!=-1)
            {
                this.deletedCureItemToServices.splice(index,1)
                cureItemToService.isDeleted=false;
            }

        }
        cureItemToServiceData.clear =  function()
        {
            cureItemToServiceData.indexCureItemToServices = [];
            cureItemToServiceData.deletedCureItemToServices = [];
        }
        cureItemToServiceData.getDeletedList =  function()
        {
            return cureItemToServiceData.deletedCureItemToServices;
        }

        return cureItemToServiceData;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/CureItemToService.js